export class Breadcrumb {
  title: string;
  url: string;

  constructor(title, url) {
    this.title = title;
    this.url = url;
  }
}
